// src/i18n.ts — Chargement dynamique des traductions (une seule langue à la fois)
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Seul le français (fallback) est chargé statiquement pour le premier rendu
import translationFR from '../translations/fr.json';

// Les autres langues sont chargées à la demande via dynamic import
const lazyResources: Record<string, () => Promise<{ default: Record<string, string> }>> = {
  en: () => import('../translations/en.json'),
  es: () => import('../translations/es.json'),
  pt: () => import('../translations/pt.json'),
};

const loadLanguage = async (lng: string) => {
  if (lng === 'fr' || i18n.hasResourceBundle(lng, 'translation')) return;
  const loader = lazyResources[lng];
  if (loader) {
    const mod = await loader();
    i18n.addResourceBundle(lng, 'translation', mod.default, true, true);
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: translationFR },
    },
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    },
    // Forcer l'utilisation de codes de langue courts (fr au lieu de fr-FR)
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

// Charger la langue détectée si ce n'est pas le français
const detectedLng = i18n.language?.split('-')[0];
if (detectedLng && detectedLng !== 'fr') {
  loadLanguage(detectedLng);
}

// Charger dynamiquement lors d'un changement de langue
i18n.on('languageChanged', (lng) => {
  loadLanguage(lng);
});

export default i18n;